import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const AboutModal = ({ show, onCancel }) => {
    const [translate] = useTranslation();

    return (
        <BootstrapModal size={"md"} show={show} backdrop="static" centered>
            <BootstrapModal.Header className="h5 text-secondary">
                {translate("OTM_ABOUT")}
            </BootstrapModal.Header>
            <BootstrapModal.Body>
                <label className="d-block h6">{translate("OTM_VERSION")}: {process.env.REACT_APP_VERSION}</label>
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
                <Button variant="secondary" onClick={() => onCancel()} className="btn-sm">{translate("OTM_CLOSE")}</Button>
            </BootstrapModal.Footer>
        </BootstrapModal>
    )
}

export default AboutModal;